import { gql } from '@apollo/client';
import { MediaFragment } from 'graphql/Media/fragments/MediaFragment';
/**
 * @const CreateMediaMutation
 * @since 1.0.0
 */
export const CreateMediaMutation = gql `
  mutation CreateMediaMutation($input: CreateMediaInput!) {
    createMedia(input: $input) {
      ...MediaFragment
    }
  }

  ${MediaFragment}
`;
